import { ModelFactory } from "../../ModelFactory";
import { Entity, entityFactory } from "./Entity";

export class SshKey {
  constructor(
    public readonly id: string,
    public readonly displayName: string,
    public readonly type: 'deployment' | 'personal',
    public readonly fingerprint: string,
    public readonly uses: number | null,
    public readonly entities: Entity[] | null,
    public readonly created: Date,
  ) {
  }
}

class SshKeyFactory extends ModelFactory<SshKey> {
  protected fromJson(json: any): SshKey {
    return new SshKey(
      json['id'],
      json['display_name'],
      json['type'],
      json['fingerprint'],
      json['entity_count'] ?? null,
      json['entities'] ? entityFactory.fromItemsResponse(json['entities']) : [],
      new Date(json['created_at']),
    );
  }
}
export const sshKeyFactory = new SshKeyFactory();
